export default "__VITE_ASSET__B8nf9jdE__"